import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import privateRequest from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
import moment from "moment";

function CanceledJob() {
  const [jobs, setJobs] = useState();

  const getJobsUpcoming = async () => {
    try {
      setJobs("");
      const response = await privateRequest.get(`jobs/GetJob?status=cancelled`);
      console.log("jobs", response?.data.data);
      setJobs(response?.data?.data?.jobs);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  useEffect(() => {
    getJobsUpcoming();
  }, []);

  return (
    <>
      {jobs?.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}

      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">
                        Canceled Jobs ( {jobs?.length} )
                      </span>
                    </p>
                  </div>
                </header>
                <div className="page-section">
                  <div className="row" data-select2-id="9">
                    <div className="col-lg-12" data-select2-id="8"></div>
                    <div className="col-lg-12">
                      <div className="card" style={{ borderRadius: "15px" }}>
                        <div className="card-body">
                          <table
                            id="my_table"
                            className="table table-sm table-striped table-hover table-bordered text-center table-responsive"
                          >
                            <thead className="bg-primary text-white">
                              <tr>
                                <th>SNo.</th>
                                <th>Job id</th>
                                <th>SP Name</th>
                                <th>Scheduled Date & Time</th>
                                <th>Category</th>
                                <th>Customer</th>
                                <th>Address</th>
                                <th>User Type</th>
                              </tr>
                            </thead>
                            <tbody className="text-center">
                              {jobs
                                ? jobs?.map((item, index) => {
                                    console.log("item", item);
                                    let job_note = item.updateLogs.filter(
                                      (item) => item.action == "Jobnotes"
                                    );
                                    console.log("job_note", job_note);
                                    function convertUTCToIST(utcDate) {
                                      const date = new Date(utcDate);
                                      date.setHours(date.getHours() + 5);
                                      date.setMinutes(date.getMinutes() + 30);
                                      return date;
                                    }
                                    return (
                                      <tr key={index}>
                                        <td className="align-middle">
                                          {index + 1}
                                        </td>
                                        <td className="align-middle">
                                          <Link
                                            target="_blank"
                                            to={`/jobDetails/${item?.jobId}`}
                                          >
                                            <span
                                              className="d-block mb-1 jobID"
                                              style={{
                                                fontSize: "16px",
                                                letterSpacing: "1px",
                                                marginBottom: "10px!important",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {item?.jobId}
                                            </span>
                                          </Link>

                                          {item?.jobStatus == 0 && (
                                            <label className="badge badge-primary">
                                              Schedule
                                            </label>
                                          )}
                                          {item?.jobStatus == 1 && (
                                            <label className="badge badge-primary">
                                              Open
                                            </label>
                                          )}
                                          {item?.jobStatus == 2 && (
                                            <label className="badge badge-warning">
                                              Start Journey
                                            </label>
                                          )}
                                          {item?.jobStatus == 3 && (
                                            <label className="badge badge-warning">
                                              Stop Journey
                                            </label>
                                          )}
                                          {item?.jobStatus == 4 && (
                                            <label className="badge badge-primary progressBtn">
                                              Progress
                                            </label>
                                          )}
                                          {item?.jobStatus == 5 && (
                                            <label className="badge badge-primary pauseBtn">
                                              Pause
                                            </label>
                                          )}
                                          {item?.jobStatus == 6 && (
                                            <label className="badge badge-primary progressBtn ">
                                              Progress
                                            </label>
                                          )}
                                          {item?.jobStatus == 7 && (
                                            <label className="badge badge-primary successBtn">
                                              Closed
                                            </label>
                                          )}

                                          {item?.jobStatus == 9 && (
                                            <label className="badge badge-primary pauseBtn">
                                              Canceled
                                            </label>
                                          )}
                                          {item?.jobStatus == 10 && (
                                            <label className="badge badge-primary pauseBtn">
                                              Cancel IR
                                            </label>
                                          )}
                                          {item?.jobStatus == 11 && (
                                            <label className="badge badge-primary pauseBtn">
                                              Cancel CR
                                            </label>
                                          )}
                                          {item?.jobStatus == 12 && (
                                            <label className="badge badge-primary pauseBtn">
                                              Cancel NR
                                            </label>
                                          )}

                                          {job_note && job_note.length > 0 && (
                                            <div
                                              className="jobNotesBox"
                                              style={{
                                                position: "relative",
                                                top: "0",
                                                right: "50%",
                                                left: "34%",
                                              }}
                                            >
                                              <span class="icon--inventory"></span>
                                              <div className="card card-body jobNotes">
                                                {job_note &&
                                                  job_note.map(
                                                    (item, index) => {
                                                      const utcDate =
                                                        item?.updatedAt;
                                                      const istDate =
                                                        convertUTCToIST(
                                                          utcDate
                                                        );
                                                      const datePart = istDate
                                                        .toISOString()
                                                        .slice(0, 10);
                                                      const timePart = istDate
                                                        .toISOString()
                                                        .slice(11, 16);

                                                      return (
                                                        <p className="d-flex justify-content-between align-items-center">
                                                          <span>
                                                            {index + 1}
                                                            {". "}
                                                            {item.reason}
                                                          </span>
                                                          <small>
                                                            {datePart} &nbsp;
                                                            &nbsp;
                                                            {timePart}
                                                          </small>
                                                        </p>
                                                      );
                                                    }
                                                  )}
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                        <td className="align-middle">
                                          <span className="d-block mb-1">
                                            {item?.jobAssignSProviderId?.Name}
                                          </span>
                                          {item?.jobAssignSProviderId
                                            ?.ContactNo && (
                                            <a
                                              className="text-nowrap"
                                              href="tel:8826655742"
                                            >
                                              <i className="fas fa-phone"></i>{" "}
                                              {
                                                item?.jobAssignSProviderId
                                                  ?.ContactNo
                                              }
                                            </a>
                                          )}
                                        </td>
                                        <td className="align-middle">
                                          <span className="d-block mb-1">
                                            {item?.slotDate &&
                                              moment(item?.slotDate).format(
                                                "DD-MM-YYYY"
                                              )}
                                          </span>
                                          <span
                                            className="badge badge-primary mb-1 "
                                            style={{ fontSize: "14px" }}
                                          >
                                            {item?.slotTime}
                                          </span>
                                        </td>

                                        <td className="align-middle">
                                          <span
                                            className="badge badge-danger PauseBtn mb-4"
                                            style={{
                                              backgroundColor: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {item?.couponCode || ""}
                                          </span>

                                          <span
                                            className="badge badge-success ml-1 mb-2  d-block"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {item?.cart[0]?.PCGroup.PCGName}
                                          </span>
                                        </td>
                                        <td className="align-middle">
                                          <span className="d-block">
                                            {item?.userId?.name}
                                          </span>
                                          <span className="d-block">
                                            <a
                                              href="mailto:ruby1sethi@gmail.com"
                                              className="text-dark"
                                            >
                                              {item?.userId?.email}
                                            </a>
                                          </span>
                                          <span className="d-block">
                                            <a
                                              href="tel:9958887022"
                                              className="text-dark"
                                            >
                                              <i className="fa fa-phone mr-2"></i>
                                              {item?.userId?.mobileNo}
                                            </a>
                                          </span>
                                        </td>
                                        <td className="align-middle text-center">
                                          <p className="mb-0 font-weight-bold  ">
                                            {item?.clientAddress?.SaveAs}
                                          </p>
                                          <p className="mb-0 ">
                                            {item?.clientAddress?.houseOrFlatNo}
                                            ,{item?.clientAddress?.buildingName}
                                            , {item?.clientAddress?.landmark}
                                          </p>
                                          <p className="mb-0 ">
                                            <a
                                              className="text-dark"
                                              href={
                                                `https://www.google.com/maps/search/?api=1&query=` +
                                                encodeURI(
                                                  item?.clientAddress
                                                    ?.FullAddress
                                                )
                                              }
                                              target="_blank"
                                            >
                                              <i className="fa fa-map-marker mr-2"></i>
                                              {item?.clientAddress?.FullAddress}
                                            </a>
                                          </p>
                                        </td>
                                        <td className="align-middle">
                                          <div>
                                            {item?.totalUniqueMobileNumbers >=
                                              0 &&
                                              item?.totalUniqueMobileNumbers <=
                                                6 && (
                                                <span
                                                  style={{
                                                    backgroundColor: "#cbcfd6",
                                                  }}
                                                  className="badge badge-light mb-2 d-block"
                                                >
                                                  Silver
                                                </span>
                                              )}

                                            {item?.totalUniqueMobileNumbers >
                                              6 &&
                                            item?.totalUniqueMobileNumbers <
                                              15 ? (
                                              <span className="badge badge-info mb-2 d-block ">
                                                Diamond
                                              </span>
                                            ) : null}

                                            {item?.totalUniqueMobileNumbers >
                                            15 ? (
                                              <span className="badge badge-warning mb-2 d-block ">
                                                Gold
                                              </span>
                                            ) : null}
                                          </div>
                                          <p className="mb-0 text-nowrap ">
                                            R. Count : {item?.totalReschedules}
                                          </p>
                                          <p className="mb-0 text-nowrap ">
                                            Job Count :{" "}
                                            {item?.totalUniqueMobileNumbers}
                                          </p>
                                        </td>
                                      </tr>
                                    );
                                  })
                                : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CanceledJob;
